<template>

    <div class="main">
        <div class="cbanner">
            <img src="../../../assets/images/banner_contact.jpg" />
            <div class="btext">
                <h3>联系我们</h3>
                <p>以客户为本，真诚服务，持续创新，追求卓越</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>联系我们</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="4"
                            class="el-menu-vertical-demo"
                           >
                        <router-link :to="{ path: '/cooperativePartner' }">
                            <el-menu-item index="1"><span slot="title" >合作伙伴</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/lawStatement' }">
                            <el-menu-item index="2"><span slot="title">法律申明</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/recruitment' }">
                            <el-menu-item index="3"><span slot="title">招贤纳士</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/contactUs' }">
                            <el-menu-item index="4"><span slot="title">联系我们</span></el-menu-item>
                        </router-link>
                      <router-link :to="{ path: '/centerAnswer' }">
                        <el-menu-item index="5"><span slot="title">平台问答</span></el-menu-item>
                      </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <!-- contact -->
                        <div class="con" v-html="htmlBody">
                        </div>
                        <!-- contact END -->
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import  {reqContactUs} from '../../../api/contentManagement-api'
    export default {
        data() {
            return {
                htmlBody:'',
            }
        },
        methods: {
            getContactUs(){
              reqContactUs().then((res)=>{
                  if(res.data.code===1){
                      this.htmlBody=res.data.data[0].content;
                  }else {
                      this.htmlBody='<p>抱歉，暂无数据</p>'
                  }
              })
            },
    },
        mounted() {
            this.$store.dispatch('showHF');
            this.getContactUs();
            }
    }
</script>



// WEBPACK FOOTER //
// src/components/contentManagement/otherPage/contactUs.vue